export default __webpack_public_path__ + "assets/images/986e87c752f4f8eb930d36d26cae1fbc.png";